
import axois from '../utils/axiosExport'

// 查询购物车 
export function shoppingCart(data?: any) {
  return axois.request({
    url: `/admin/shopping-cart/list`,
    method: "GET",
    data: {
      ...data,
    },
  });
}  
// 更新购物车
export function updateShoppingCart(data?: any) {
  return axois.request({
    url: `/admin/shopping-cart/update`,
    method: "POST",
    data: {
      ...data,
    },
  });
}
// 删除购物车
export function deleteShoppingCart(id?: any) {
  return axois.request({
    url: `/admin/shopping-cart/delete/${id}`,
    method: "DELETE", 
  });
}
// 添加订单
export function addOrder(data?: any) {
  return axois.request({
    url: `/admin/order/add`,
    method: "POST",
    data: {
      ...data,
    },
  });
}